import {stringToTokenAmount} from '#/utils/token-string-utils';
import {useState} from 'react';

type WalletTransferTokenInputHandlers = {
  inputValue: string;
  getInitialInputValue: () => string;
  onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMaxButtonClick: () => void;
  inputAboveBalance: boolean;
};
export const useWalletTransferTokenInputHandlers = (
  balance: bigint,
  getInitialInputValue: () => string,
): WalletTransferTokenInputHandlers => {
  const [inputValue, setInputValue] = useState(getInitialInputValue());
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };
  const onMaxButtonClick = () => {
    setInputValue(getInitialInputValue());
  };
  const inputAboveBalance = stringToTokenAmount(inputValue) > Number(balance);

  return {
    inputValue,
    getInitialInputValue,
    onInputChange,
    onMaxButtonClick,
    inputAboveBalance,
  };
};
